<div class="modal-header">
  <div>
    <h4 class="modal-title mb-1">{{ participantName }}</h4>
    <p class="text-muted mb-0">
      {{ 'bookingModule.bookings' | translate }}
    </p>
  </div>
  <button
    type="button"
    class="btn-close"
    attr.aria-label="{{ 'general.close' | translate }}"
    (click)="bsModalRef.hide()"
  ></button>
</div>

<div class="modal-body">
  <div class="table-responsive" *ngIf="bookingRows.length; else emptyState">
    <table class="table table-borderless table-striped align-middle mb-0">
      <thead class="table-light">
        <tr>
          <th scope="col">{{ 'general.id' | translate }}</th>
          <th scope="col">{{ 'productModule.product' | translate }}</th>
          <th scope="col">{{ 'bookingModule.linkedProduct' | translate }}</th>
          <th scope="col">{{ 'general.from' | translate }}</th>
          <th scope="col">{{ 'general.to' | translate }}</th>
          <th scope="col">{{ 'general.status' | translate }}</th>
          <th scope="col" class="text-center">{{
            'general.attending' | translate
          }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of bookingRows">
          <td>
            <a
              [routerLink]="['/bookings', row.booking.id]"
              target="_blank"
              rel="noopener noreferrer"
              [attr.aria-label]="
                '#' +
                row.booking.id +
                ' - ' +
                ('bookingModule.viewBookings' | translate) +
                ' - ' +
                ('wcag.openInNewWindow' | translate)
              "
            >
              {{ row.booking.id }}
            </a>
          </td>
          <td>
            {{
              (row.booking.productId
                | getTranslation: 'product' : 'description'
                | async) || row.booking.product?.description
            }}
          </td>
          <td>
            <ng-container *ngIf="row.booking.linkedProductId; else noProduct">
              {{
                (row.booking.linkedProductId
                  | getTranslation: 'product' : 'description'
                  | async) || row.booking.linkedProduct?.description
              }}
            </ng-container>
            <ng-template #noProduct>{{
              'general.none' | translate
            }}</ng-template>
          </td>
          <td>
            {{ row.booking.startDate | formatDate: 'd MMM y HH:mm' | async }}
          </td>
          <td>
            {{ row.booking.endDate | formatDate: 'd MMM y HH:mm' | async }}
          </td>
          <td>
            <ng-container
              *ngIf="
                row.participationStatus !== undefined;
                else noParticipationStatus
              "
            >
              {{
                'participationModule.participationStatus' +
                  row.participationStatus | translate
              }}
            </ng-container>
            <ng-template #noParticipationStatus>
              {{ 'courseModule.notAttending' | translate }}
            </ng-template>
          </td>
          <td class="text-center">
            <i
              role="img"
              [attr.aria-label]="
                row.participationStatus === 3
                  ? ('participationModule.participationStatus3' | translate)
                  : row.isAttending
                    ? ('general.yes' | translate)
                    : ('general.no' | translate)
              "
              [ngClass]="
                row.participationStatus === 3
                  ? 'fas fa-exclamation-triangle text-warning'
                  : row.isAttending
                    ? 'fas fa-check text-success'
                    : 'fas fa-times text-danger'
              "
            ></i>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <ng-template #emptyState>
    <div class="alert alert-light border mb-0" role="alert">
      {{ 'courseModule.noCourseBookings' | translate }}
    </div>
  </ng-template>
</div>
